import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router'
import { createFeedback } from '@workspace/api-backend'
import { AuthGuard } from '../components/auth-guard'
import { FeedbackButton } from '../components/feedback-button'

export const Route = createFileRoute('/_protected')({
  component: ProtectedLayout,
})

function ProtectedLayout() {
  const matchRoute = useMatchRoute()
  const isOnboarding = matchRoute({ to: '/join', fuzzy: true })

  async function handleFeedbackSubmit(data: {
    message: string
    pageUrl: string
    userAgent: string
  }) {
    await createFeedback({ body: data })
  }

  return (
    <AuthGuard>
      <Outlet />
      {!isOnboarding && <FeedbackButton onSubmit={handleFeedbackSubmit} />}
    </AuthGuard>
  )
}
